export default "__VITE_ASSET__WqNnueSV__"